<template>
  <v-container fluid
    ><amplify-auth-container>
      <amplify-authenticator>
        <amplify-sign-in
          slot="sign-in"
          hide-sign-up="false"
          :formFields="formFields"
        ></amplify-sign-in>
        <!-- <amplify-sign-out></amplify-sign-out> -->
      </amplify-authenticator></amplify-auth-container
    >
  </v-container>
</template>

<script>
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
//import { layout } from "@/mixins";

export default {
  name: "VueAuthenticator",
  //mixins: [layout],
  data() {
    return {
      // user: undefined,
      // theme: "qbuilder",
      authState: undefined,
      unsubscribeAuth: undefined,
      formFields: [
        {
          type: "email",
          inputProps: { required: true, autocomplete: "Username" },
        },
        {
          type: "password",
          inputProps: { required: true, autocomplete: "Password" },
        },
      ],
    };
  },
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState) => {
      this.authState = authState;
      // this.$store.commit("auth/setUser", authData);
      //this.user = authData;
    });
  },
  methods: {
    // ...mapActions({
    //   authAction: "auth/authAction",
    // }),
  },
  watch: {
    authState: {
      handler() {
        // console.log("watch>authState", this.authState);
        if (this.authState === AuthState.SignedIn) {
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          }
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.unsubscribeAuth();
  },
};
</script>
<style>
:root {
  --amplify-primary-color: #4caf50;
  --amplify-primary-tint: #66bb6a;
  --amplify-primary-shade: #43a047;
}
/* .button {
  border-radius: 3px !important;
} */
</style>
